import React from "react";
import TablaBeneficio from "js/components/TablaCatalogoCodigos";

function Beneficio(props) {
  return <TablaBeneficio />;
}

export default Beneficio;
